import { useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams, Link } from "react-router-dom";
import { api, errMsg } from "@/lib/api";
import { Logo } from "@/components/Logo";

export default function Iniciar() {
  const { vertical } = useParams();
  const [sp] = useSearchParams();
  const nav = useNavigate();
  const [err, setErr] = useState(null);
  useEffect(() => {
    const ref = sp.get("ref") || localStorage.getItem("fb_ref");
    api.get(`/public/onboarding/start/${vertical}`, { params: ref ? { ref } : {} })
      .then(({ data }) => { const q = new URLSearchParams(); ["sim", "segment", "product"].forEach((k) => sp.get(k) && q.set(k, sp.get(k))); nav(data.url + (q.toString() ? `?${q}` : ""), { replace: true }); })
      .catch((e) => setErr(errMsg(e)));
  }, [vertical]); // eslint-disable-line
  return (
    <div className="min-h-screen ink grid place-items-center p-6" data-testid="iniciar-page">
      <div className="flex flex-col items-center gap-4 text-center"><Logo dark size={44} />
        {err ? <><p className="text-red-300 text-sm" data-testid="iniciar-error">{err}</p><Link to="/" className="text-[#FFC629] text-sm underline">Volver al inicio</Link></> : <p className="text-white/60 text-sm">Preparando tu solicitud…</p>}
      </div>
    </div>
  );
}
